import * as React from "react";
import { useApi } from "src/Api/useApi";
import { Spinner } from "src/components/common";

export const apiHOC = (WrappedComponent: any) => {
	return (props: any) => {
		const api = useApi();
		return <WrappedComponent api={api} {...props} />;
	};
};
